import { PurchasingContainer, PurchasingRegister } from '@Purchasing/Data/DataSource/Container'
import { useCallback, useEffect, useState } from 'react'
import { ProductionLinksResult } from '@Purchasing/Domain/Model/PurchaseProcess'

export const useProductionLinks = (processId?: string, enabled = true) => {
    const get = PurchasingContainer.get(PurchasingRegister.UseCaseGetProductionLinks)
    const confirm = PurchasingContainer.get(PurchasingRegister.UseCaseConfirmProductionLink)
    const unlink = PurchasingContainer.get(PurchasingRegister.UseCaseUnlinkProductionLink)
    const refresh = PurchasingContainer.get(PurchasingRegister.UseCaseRefreshProduction)
    const [data, setData] = useState<ProductionLinksResult | null>(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const reload = useCallback(async () => {
        if (!processId || !enabled) return
        setLoading(true)
        try {
            setError(null)
            setData(await get.execute(processId))
        } catch {
            setError('Não foi possível atualizar os dados de produção.')
        } finally { setLoading(false) }
    }, [get, processId, enabled])
    useEffect(() => { reload() }, [reload])

    const confirmLink = async (id: string) => { if (!processId) return; await confirm.execute(processId, id); await reload() }
    const unlinkLink = async (id: string) => { if (!processId) return; await unlink.execute(processId, id); await reload() }
    const refreshFromSource = async () => {
        if (!processId) return
        try {
            setError(null)
            await refresh.execute(processId)
            await reload()
        } catch {
            setError('Não foi possível atualizar os dados de produção.')
        }
    }
    return { data, loading, error, reload, confirmLink, unlinkLink, refreshFromSource }
}
